// extracted by mini-css-extract-plugin
export var firstLineTextCompact = "dbOlm";
export var firstLineTextMedium = "JxwJ6";
export var firstLineTextRead = "ESO13";
export var firstLineTextSCLTypeRampCompact = "nUo8r";
export var firstLineTextSCLTypeRampFull = "wdqIM";
export var firstLineTextSCLTypeRampMedium = "rnqAg";
export var firstLineTextUnread = "JBWmn";
export var mclFirstLineTextUnread = "DOWm0";
export var mclFirstLineTextUnreadTypeRamp = "LCQlV";
export var mclFirstLineTextUnreadTypeRampSelected = "dEHFj";